// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1YXWT","cell":"ColumnAccessor_cell__1dlrH","firstCellAccent":"ColumnAccessor_firstCellAccent__1HDD5"};